import { ManualAnalysisPanelState } from "@/@types/vuex";

export default {} as ManualAnalysisPanelState;
